export const date = [
  { key: "最近一个月", value: "one_month" },
  { key: "最近三个月", value: "three_month" },
  { key: "最近半年", value: "six_month" },
  /*{ key: "2018年", value: "2018" },
  { key: "2017年", value: "2017" },
  { key: "2016年", value: "2016" }*/
];

export const manager_status = [
  { key: "培训班未提交", value: "Edit" },
  { key: "培训班审核中", value: "Audit" },
  { key: "培训班审核拒绝", value: "Refused" },
  { key: "培训班未开始", value: "Initiated" },
  { key: "培训班进行中", value: "Incomplete" },
  { key: "考试已结束", value: "Finalised" },
  { key: "成绩审核中", value: "ScoreAudit" },
  { key: "成绩审核拒绝", value: "ScoreRefused" },
  { key: "成绩已确认(编号中)", value: "ScoreAffirm" },
  { key: "培训班已完成", value: "Complete" },
];

export const manager_status_system = [
  { key: "培训班审核中", value: "Audit" },
  { key: "培训班审核拒绝", value: "Refused" },
  { key: "培训班未开始", value: "Initiated" },
  { key: "培训班进行中", value: "Incomplete" },
  { key: "考试已结束", value: "Finalised" },
  { key: "成绩审核中", value: "ScoreAudit" },
  { key: "成绩审核拒绝", value: "ScoreRefused" },
  { key: "成绩已确认(编号中)", value: "ScoreAffirm" },
  { key: "培训班已完成", value: "Complete" }
];

export const class_manager_status = [
  { key: "培训班未提交", value: "Edit" },
  { key: "培训班审核中", value: "Audit" },
  { key: "培训班审核拒绝", value: "Refused" },
  { key: "培训班未开始", value: "Initiated" },
  { key: "培训班进行中", value: "Incomplete" },
  { key: "考试已结束", value: "Finalised" },
  { key: "培训班已完成", value: "Complete" }
];

export const class_score_status = [
  { key: "成绩审核中", value: "ScoreAudit" },
  { key: "成绩审核拒绝", value: "ScoreRefused" },
  { key: "成绩已确认(编号中)", value: "ScoreAffirm" },
  { key: "培训班已完成", value: "Complete" }
];

export const user_status = [
  { key: "培训班审核中", value: "Audit" },
  { key: "培训班未开始", value: "Initiated" },
  { key: "培训进行中", value: "Incomplete" },
  { key: "考试已结束", value: "Finalised" },
  { key: "成绩审核中", value: "ScoreAudit" },
  { key: "成绩审核拒绝", value: "ScoreRefused" },
  { key: "成绩已确认(编号中)", value: "ScoreAffirm" },
  { key: "培训班已完成", value: "Complete" },
];

export const teacher_level = [
  { key: "职业级讲师", value: "0" },
  { key: "A级讲师", value: "A" },
  { key: "B级讲师", value: "B" },
  { key: "C级讲师", value: "C" },
  { key: "D级讲师", value: "D" },
  { key: "D级助理", value: "E" },
];

export const tutorial_types = [
  { key: "全部教案", value: "" },
  { key: "实践教案", value: "practice" },
  { key: "考试教案", value: "exam" },
];

export const evaStatus = [
  { key: "未调查", value: "N" },
  { key: "已调查", value: "Y" },
];

export const levelName = {
  "A": "A级教练员培训班",
  "B": "B级教练员培训班",
  "C": "C级教练员培训班",
  "D": "D级教练员培训班",
};

export const levelOptions = [
  /*{
    val: "A",
    text: "A级"
  },
  {
    val: "B",
    text: "B级"
  },*/
  {
    val: "D",
    text: "D级"
  },
  {
    val: "C",
    text: "C级"
  },
];

export const highClassLevelList = [
  { key: "C级", value: "C" },
  { key: "B级", value: "B" },
 { key: "A级", value: "A" },
 { key: "职业级", value: "PRO" },
];

export const classLevelList = [
  { key: "D级", value: "D" },
  { key: "C级", value: "C" },
  { key: "B级", value: "B"},
  { key: "A级", value: "A"},
];

export const enrollStatus = [
  { key: "暂时保存", value: "enrollEdit" },
  { key: "报名未开始", value: "enrollInitiated" },
  { key: "报名进行中", value: "enrollIncomplete" },
  { key: "报名已结束", value: "enrollFinalised" },
  { key: "报名已完成", value: "enrollComplete" },
  { key: "报名已关闭", value: "enrollClose" },
];
export const HidgClassStatus = [
  { key: "培训班未提交", value: "Edit" },
  { key: "培训班未开始", value: "Initiated" },
  { key: "培训班进行中", value: "Incomplete" },
  { key: "考试已结束", value: "Finalised" },
  { key: "成绩审核中", value: "ScoreAudit" },
  { key: "成绩审核拒绝", value: "ScoreRefused" },
  { key: "成绩已确认(编号中)", value: "ScoreAffirm" },
  { key: "培训班已完成", value: "Complete" },
];

export const personnelStatus = [
  { key: "会员协会拒绝", value: "personnelRefused" },
  { key: "会员协会推荐", value: "personnelThrough" },
  { key: "会员协会审核中", value: "personnelSubmitted" },
  { key: "报名审核拒绝", value: "enrollCheckRefused" },
  { key: "报名审核通过", value: "enrollCheckThrough" },
  // { key: "中国足协已录取", value: "personnelAdmit" },
  // { key: "中国足协未录取", value: "personnelUnadmit" },

];
export const personnelExamStatus = [
  // { key: "中国足协已录取", value: "personnelAdmit" },
  // { key: "中国足协未录取", value: "personnelUnadmit" },
  { key: "补考申请待处理", value: "examPersonnel" },
  { key: "补考审核拒绝", value: "examRefused" },
  { key: "补考审核通过", value: "examThrough" },
];
// 专项培训讲师级别
export const proLevellist = [
{key:'无',value:''},
{key:"亚足联体能讲师",value:'stamina'},
{key:"亚足联守门员讲师",value:"goaltender"}
];

// 教练员级别
export const colLevellist=[
  { key: "亚足联/中国足协职业级教练员", value: "0" },
  { key: "亚足联/中国足协A级教练员", value: "A" },
  { key: "亚足联/中国足协B级教练员", value: "B" },
  { key: "中国足协C级教练员", value: "C" },
  { key: "中国足协D级教练员", value: "D" },
  {key:"亚足联守门员教练L1",value:'G-L1'},
  {key:"亚足联守门员教练L2",value:'G-L2'},
  {key:"亚足联守门员教练L3",value:'G-L3'},
  {key:"亚足联体能教练L1",value:'S-L1'},
  {key:"亚足联体能教练L2",value:'S-L2'}
];

export const  qualificationList=[
  {key:'小学',value:'小学'},
  {key:'初中',value:'初中'},
  {key:'高中 ',value:'高中 '},
  {key:'职专',value:'职专'},
  {key:'大专',value:'大专'},
  {key:'本科',value:'本科'},
  {key:'硕士',value:'硕士'},
  {key:'博士',value:'博士'},
];

export const teamList=[
  {key:'业余球队',value:'业余球队'},
  {key:'校队',value:'校队'},
  {key:'市队',value:'市队'},
  {key:'省队',value:'省队'},
  {key:'职业俱乐部梯队',value:'职业俱乐部梯队'},
  {key:'中冠',value:'中冠'},
  {key:'中乙',value:'中乙'},
  {key:'中甲(甲B)',value:'中甲(甲B)'},
  {key:'中超(甲A)',value:'中超(甲A)'},
  {key:'国少',value:'国少'},
  {key:'国青',value:'国青'},
  {key:'国奥',value:'国奥'},
  {key:'国家队',value:'国家队'},
  {key:'其他',value:'其他'}
];

export const tea_level = [
  { key: "亚足联/中国足协职业级讲师", value: "0" },
  { key: "亚足联/中国足协A级讲师", value: "A" },
  { key: "亚足联/中国足协B级讲师", value: "B" },
  { key: "中国足协C级讲师", value: "C" },
  { key: "中国足协D级讲师", value: "D" },
  { key: "中国足协D级助教", value: "E" },
];

export const enroll_type_list=[
  {key:"继续教育报名",value:"continue_education",disabled:true},
  {key:"培训报名",value:"common",disabled:false},
  {key:"补考报名",value:"make_up_exam",disabled:false}
];

export const class_train_type_list=[
  {key:"继续教育培训",value:"continue_education",disabled:true},
  {key:"等级培训",value:"train",disabled:false}
];

export const enroll_type_list_org=[
  {key:"继续教育报名",value:"continue_education"},
  {key:"培训报名",value:"common"}
];

export const  quaLevelList = [
  { key: "职业级", value: "P" },
  { key: "A级", value: "A" },
  { key: "B级", value: "B" },
  { key: "C级", value: "C" },
  { key: "D级", value: "D" },
];
export const  quaLevelListAll = [
  { key: "职业级", value: "P" },
  { key: "A级", value: "A" },
  { key: "B级", value: "B" },
  { key: "C级", value: "C" },
  { key: "D级", value: "D" },
  { key: "岗位培训初级", value: "初" },
  { key: "岗位培训中级", value: "中" },
  { key: "岗位培训高级", value: "高" },
  { key: "职业级继续教育", value: "P(继)" },
  { key: "A级继续教育", value: "A(继)" },
  { key: "B级继续教育", value: "B(继)" },
  { key: "C级继续教育", value: "C(继)" },
  { key: "国际教练员资质认证(职业级)", value: "P(国际)" },
  { key: "国际教练员资质认证(A级)", value: "A(国际)" },
  { key: "国际教练员资质认证(B级)", value: "B(国际)" },
  { key: "国际教练员资质认证(C级)", value: "C(国际)" },
];

export const  train_type_list = [
  { key: "等级培训", value: "level" },
  { key: "岗位培训", value: "job" },
  { key: "继续教育", value: "education" },
  { key: "国际教练员资质认证", value: "international" },
];
export const  job_list = [
  { key: "初级", value: "初" },
  { key: "中级", value: "中" },
  { key: "高级", value: "高" },
];
export const  audit_edu_list = [
  { key: "职业级", value: "P" },
  { key: "A级", value: "A" },
  { key: "B级", value: "B" },
  { key: "C级", value: "C" },
];
export const  international_list = [
  { key: "职业级", value: "P" },
  { key: "A级", value: "A" },
  { key: "B级", value: "B" },
  { key: "C级", value: "C" },
];

export const  punish_type_list=[
  {label:'假证',value:'fakes'},
  {label:'处罚',value:'punish'},
  {label:'其他',value:'other'},
]
export const  punish_status_list=[
  {label:'封禁中',value:'0'},
  {label:'已移出',value:'1'},
  {label:'已解禁',value:'2'},
]
export const  licenseWaitList = [
  { key: "职业级", value: "0" },
  { key: "A级", value: "A" },
  { key: "B级", value: "B" },
  { key: "C级", value: "C" },
  { key: "D级", value: "D" },
];

export const genderList=[
  {key:'女',val:'女'},
  {key:'男',val:'男'},
];

export const licenseDistributeWay=[
  {key:'邮寄或自取',val:'invite_or_mail'},
  {key:'邮寄',val:'mail'},
  {key:'自取',val:'invite'},
];

// 培训地区
export const trainingRegionList=[
  {key:'中国大陆',value:'territory_of_China'},
  {key:'港澳台',value:'HMT'},
  {key:'其他',value:'other'},
];

// 证件类型
export const id_types=[
  {key: "中国居民身份证", value: "id_number"},
  {key: "外国人永久居留身份证", value: "idTypeCode_wgjzz"},
  {key: "港澳台居民居住证", value: "idTypeCode_HMT"},
  {key: "港澳居民来往内地通行证", value: "HM"},
  {key: "台湾居民来往大陆通行证", value: "TAI"},
  {key: "护照（仅国外教练员使用）", value: "passport"}
];
